import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";
import pako from "pako";
import { Button, Form } from "reactstrap";
import { InternetCut } from "components";
import APIs from "services/APIs";
import { Header } from "components/Layout";
import "../../styles/index.scss";
import "./Home.style.scss";

class Home extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalYears: 0,
      search: "",
      entries: 0,
      isLoading: false,
    };
  }

  handleChange = (e) => {
    const value = e.target.value;
    this.setState({
      search: value,
    });
  };

  componentDidMount() {
    this.getInfo();

    const date = new Date();
    const currentYear = date.getFullYear();
    this.setState({
      totalYears: currentYear - 1994 + 1,
    });
  }

  getInfo = () => {
    this.setState({
      isLoading: true,
    });
    APIs.getInfo().then(({ status, entries_count: entries, last_updated }) => {
      if (status === "success") {
        this.setState({
          entries,
          updated_at: moment(last_updated).fromNow(false),
        });
      }
      this.setState({
        isLoading: false,
      });
    });
  };

  submitSearch = () => {
    const { search } = this.state;
    this.props.history.push("/search?q=" + search);
  };

  render() {
    const {
      search = "",
      entries,
      updated_at,
      isLoading,
      totalYears,
    } = this.state;

    const loader = <i className="fas fa-spinner fa-spin"></i>;

    return (
      <div className="home">
        <InternetCut />
        <Header />
        <div className="d-flex align-items-center justify-content-center home-inner">
          <div>
            <div className="text-center logo">
              <img src="/images/logo.png" alt="" />
            </div>
            <p className="text-center">
              Explore {totalYears} years of sanctions data
            </p>
            <Form onSubmit={this.submitSearch}>
              <div className="search-bar d-flex">
                <input
                  className="form-control home-search"
                  type="text"
                  placeholder="Search OFAC, UN and EU"
                  value={search}
                  onChange={this.handleChange}
                />
                <div className="submit-buttons" id="submit-button-inline">
                  <Button color="primary" onClick={this.submitSearch}>
                    <img src="/icons/png/search.png" alt="" />
                  </Button>
                </div>
              </div>
            </Form>

            <p className="mt-2">
              {isLoading ? loader : new Intl.NumberFormat().format(entries)}{" "}
              entries across OFAC, UN and EU. Updated{" "}
              {isLoading ? loader : updated_at}.
            </p>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(Home);
